import { render, staticRenderFns } from "./table-cell-inheritance.vue?vue&type=template&id=b6e1cd02&"
import script from "./table-cell-inheritance.vue?vue&type=script&lang=js&"
export * from "./table-cell-inheritance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports